import _ from 'lodash';
import { STORYZ_TOP_FOLDER } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  result: {},
};

/**
 * StoryZTopFolder Reducer
 * @param {*} state
 * @param {*} action
 */
export default function storyZTopFolder(state = initialState, action = {}) {
  switch (action.type) {
    case `${STORYZ_TOP_FOLDER}_PENDING`:
      return {
        ...state,
        error: null, // state.error = null
        loaded: false, // state.loaded = false
        loading: true, // state.loading = true
      };
    case `${STORYZ_TOP_FOLDER}_SUCCESS`:
      let storyZList;
      if (action.bStart === 0) {
        storyZList = action?.result?.data?.attributes?.items;
      } else {
        storyZList = _.concat(
          state.storyZList ?? [],
          action?.result?.data?.attributes?.items,
        );
      }
      return {
        ...state,
        error: null,
        result: action?.result,
        storyZList: storyZList,
        loaded: true,
        loading: false,
      };
    case `${STORYZ_TOP_FOLDER}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
